import { handleActions } from 'redux-actions';
import produce from 'immer';
import {
	POST_OTP_SEND_CODE_CALL, POST_OTP_SEND_CODE_DONE, POST_OTP_SEND_CODE_FAIL,
	POST_OTP_VERIFY_CALL, POST_OTP_VERIFY_DONE, POST_OTP_VERIFY_FAIL,
	RESET_OTP_STATE,
} from '@src/store/types/otp';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: null,
};

const initialState = {
	sendOtpCodeSideEffect: defaultSideEffectState,
	verifyOtpCodeSideEffect: defaultSideEffectState,
};

export default handleActions(
	{
		[POST_OTP_SEND_CODE_CALL](state) {
			return produce(state, draft => {
				draft.sendOtpCodeSideEffect = { ...defaultSideEffectState, isLoading: true };
			});
		},
		[POST_OTP_SEND_CODE_DONE](state) {
			return produce(state, draft => {
				draft.sendOtpCodeSideEffect = { ...defaultSideEffectState, isLoaded: true };
			});
		},
		[POST_OTP_SEND_CODE_FAIL](state, { payload }) {
			return produce(state, draft => {
				draft.sendOtpCodeSideEffect = { ...defaultSideEffectState, error: payload || true };
			});
		},
		[POST_OTP_VERIFY_CALL](state) {
			return produce(state, draft => {
				draft.verifyOtpCodeSideEffect = { ...defaultSideEffectState, isLoading: true };
			});
		},
		[POST_OTP_VERIFY_DONE](state) {
			return produce(state, draft => {
				draft.verifyOtpCodeSideEffect = { ...defaultSideEffectState, isLoaded: true };
			});
		},
		[POST_OTP_VERIFY_FAIL](state, { payload }) {
			return produce(state, draft => {
				draft.verifyOtpCodeSideEffect = { ...defaultSideEffectState, error: payload || true };
			});
		},
		[RESET_OTP_STATE](state) {
			return produce(state, draft => {
				draft.sendOtpCodeSideEffect = defaultSideEffectState;
				draft.verifyOtpCodeSideEffect = defaultSideEffectState;
			});
		},
	},
	initialState,
);
